import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import i18n from 'i18next';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import classNames from 'classnames';
import axios from 'axios';
import { useAuth } from '../../_common/AuthContext';

const SelectCompanyPlant = () => {
    const summitbtnRef = useRef(null);
    const navigate = useNavigate();
    const {clearAuth} = useAuth();
    const [companyPlantOptions, setCompanyPlantOptions] = useState([]);
    const [selectedCompanyPlant, setSelectedCompanyPlant] = useState(null);
    const [isSuccess, setIsSuccess] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        axios.get('/BBAuthentication/SelectCompanyPlant')
        .then(response => {
            const data = response.data;

            if (data.IsAuthenticated) {
                clearAuth();
                setIsSuccess(true);
                window.location.href = data.ReturnUrl;
            }
            else if(data.RedirectPage){
                navigate(data.RedirectPage , {state : {ErrorMessage : data.ErrorMessage}})
            }else{
                setCompanyPlantOptions(data);
                // Find the first row of data.dropdownGroups
                const firstRow = Array.isArray(data) && data.length > 0 ? data[0] : null;
                setSelectedCompanyPlant(firstRow)
            }
        })
        .catch(error => {
            setErrorMessage(i18n.t('auth.select_company_plant.fetch_error'));
            console.error(error);
        })
        .finally(() => {
            setIsLoading(false);
            if (summitbtnRef.current) {

                setTimeout(() => {
                    summitbtnRef.current.focus();
                }, 100);
            }
        });
    }, []);

    

    const handleSubmit = (e) => {
        if (e) e.preventDefault();

        setErrorMessage('');
        if (!selectedCompanyPlant) {
            setErrorMessage(i18n.t('auth.select_company_plant.please_select_a_company_and_plant'));
            return;
        }
        setIsLoading(true);

        // Simulate API call or navigation
        axios.post('/BBAuthentication/SelectCompanyPlant', { companyId: selectedCompanyPlant.CompanyID, plantId: selectedCompanyPlant.PlantID })
            .then(response => {
                setIsLoading(false);
                // Assuming the API returns a redirect URL or similar
                const data = response.data;
                clearAuth();
                if (data.IsSuccess) {
                    setIsSuccess(true);
                    window.location.href = data.ReturnUrl;
                } else {
                    setErrorMessage(data.ErrorMessage);
                }
            })
            .catch(error => {
                setIsLoading(false);
                setErrorMessage(i18n.t('auth.select_company_plant.submit_error'));
            });
    };

    const companyPlantOptionTemplate = (option) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div>{option.LabelName}</div>
                {option.IsSuggestion &&
                    <div style={{ padding: '4px', backgroundColor: '#d92f32', fontSize: '10px', marginLeft: '8px', borderRadius: '16px', color: 'white' }} >
                        latest</div>}
            </div>
        );
    };

    return (
        <div className="login-inner">
            <div className="body-inner">
                {!isSuccess && (
                    <form className="login-form" onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <h4 className="font-bold">{i18n.t('auth.select_company_plant.please_select_company_and_plant')}</h4>
                        </div>
                        <div className="mb-3">
                            <Dropdown value={selectedCompanyPlant || ''} options={companyPlantOptions} optionLabel='LabelName'
                                itemTemplate={companyPlantOptionTemplate}
                                onChange={e => {
                                    setSelectedCompanyPlant(e.value)
                                    setTimeout(() => {
                                        summitbtnRef.current.focus();
                                    }, 150);
                                }} filter
                                className={classNames({ 'p-invalid': !!errorMessage })} style={{ width: '100%', fontSize: '1.1rem' }}
                            />
                            {errorMessage && <div className="text-red-500 mb-3">{errorMessage}</div>}
                        </div>
                        <Button ref={summitbtnRef} type="submit" label={i18n.t('auth.select_company_plant.confirm')} className="w-full" loading={isLoading} disabled={isLoading} autoFocus />
                    </form>
                )}
                {isSuccess && (
                    <div className='login-form'>
                        <div className="text-2xl font-bold text-center">
                            {i18n.t('auth.auth_successfully')}
                        </div>
                        <div className="text-center" style={{marginTop: '10px'}}>
                            {i18n.t('auth.auth_redirecting')}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SelectCompanyPlant; 